import { put } from 'redux-saga/effects';

import * as AppActions from '../../../actions';
import { getInDomain } from '../../../domains/externalUtils';
import Logger from '../../../tools/Logger';

const log = Logger.child({
  component: 'mediator/closeSearch',
});

export function* closeSearch({ payload: { searchType = 'mainSearch' } }) {
  log.debug(`executing closeSearch(action) useCase worker searchType:${searchType}`);

  const searchUIStateUpdate = getInDomain('searchT3.actions.searchUIStateUpdate');
  const searchTermUpdate = getInDomain('searchT3.actions.searchTermUpdate');
  const resetResults = getInDomain('searchT3.actions.resetResults');
  yield put(
    searchUIStateUpdate({
      active: false,
      hasFocus: false,
      searchType,
    }),
  );
  yield put(
    searchTermUpdate({
      searchTerm: '',
      searchFilter: getInDomain('searchT3.constants.SearchKeys').ALL,
      searchType,
    }),
  );
  yield put(resetResults());
  yield put(AppActions.Application.leaveSearch());
}
